import {FlowLang} from 'flow-to-typescript-codemod';
import * as React from 'react';
import {useMergeRefs} from '@floating-ui/react';
import useHitarea, {
  type State as HitareaState,
  type Handlers as HitareaHandlers,
} from '@packages/systems/ui/hooks/useHitarea';

import {safeMergeProps, safeCloneElement} from '@packages/utilities/component';
import {omitChildren} from '@packages/utilities/props';

export type Provides = HitareaState & HitareaHandlers;

type Props = {
  // TODO: figure out how to type cloneElement mixing in things
  children: React.ReactElement<
    // @ts-expect-error - TS2344 - Type 'Diff<any, Provides>' does not satisfy the constraint 'keyof IntrinsicElements | JSXElementConstructor<any>'.
    React.ComponentProps<FlowLang.Diff<any, Provides>>
  >;
};

const Hitarea = React.forwardRef<HTMLElement, Props>(
  function Hitarea(
    props,
    ref
  ): React.ReactElement<React.ComponentProps<React.ComponentType<Provides>>> {
    // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
    const [state, handlers] = useHitarea();
    const hitareaProps = React.useMemo(
      () => ({...state, ...handlers}),
      [state, handlers]
    );

    const existingRef = React.useMemo(
      () =>
        React.isValidElement(props.children) && 'ref' in props.children
          ? (props.children.ref as React.Ref<unknown>)
          : undefined,
      [props.children]
    );
    const mergedRef = useMergeRefs([ref, existingRef]);

    return safeCloneElement(
      safeMergeProps(omitChildren(props), hitareaProps),
      props.children,
      ref ? mergedRef : undefined
    );
  }
);

export default Hitarea;
